import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';

import { toast } from 'react-toastify';
import { Text } from '../../components';
import { adminApi, validateAdminMagic } from '../../service';

function AdminMagic() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const magic = searchParams.get('ref');
      if (magic) {
        try {
          const { data: { token: magicToken } = {} } = await validateAdminMagic({ token: magic });
          adminApi.defaults.headers.common['Authorization'] = `Bearer ${magicToken}`;
          try {
            localStorage.setItem('adminToken', magicToken);
            navigate('/admin/dashboard');
          } catch (error) {
            navigate('/admin/login');
          }
        } catch (error) {
          toast.error(t('verifyLogin.error'));
          navigate('/admin/login');
        }
      } else {
        navigate('/admin/login');
      }
    })();
  }, [navigate]);

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-teal-10/80 backdrop-blur-sm flex items-center justify-center flex-col gap-4">
      <FadeLoader color="#2E3583" size={100} />
      <Text type={'medium'} text={t('verifyLogin.verifying')} className="text-center" />
    </div>
  );
}

export default AdminMagic;
